import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'HousingAssociationHistoryIssueListController',
            HousingAssociationHistoryIssueListController
        );

    /** @ngInject */
    function HousingAssociationHistoryIssueListController(
        $scope,
        HaEmployeeFactory,
        HousingAssociationsFactory
    ) {
        var vm = this;
        $scope.pageSize = 10;

        vm.countYears = function (startYear) {
            var date = new Date();
            var currentYear = date.getFullYear();
            var yearsList = [];
            for (var i = startYear; i <= currentYear; i++) {
                yearsList.push(i);
            }
            return yearsList;
        };

        vm.months = [
            { name: 'Styczeń', id: 1 },
            { name: 'Luty', id: 2 },
            { name: 'Marzec', id: 3 },
            { name: 'Kwiecień', id: 4 },
            { name: 'Maj', id: 5 },
            { name: 'Czerwiec', id: 6 },
            { name: 'Lipiec', id: 7 },
            { name: 'Sierpień', id: 8 },
            { name: 'Wrzesień', id: 9 },
            { name: 'Październik', id: 10 },
            { name: 'Listopad', id: 11 },
            { name: 'Grudzien', id: 12 },
        ];

        vm.readMore = function () {
            $scope.pageSize = $scope.pageSize + 5;
        };

        $scope.$watch('[pageSize, selectedYear, selectetMonth]', function () {
            var paramList = {
                page: 1,
                page_size: $scope.pageSize,
                created_at_year: $scope.selectedYear,
                created_at_month: $scope.selectedMonth,
                active: false,
            };

            HaEmployeeFactory.readMe().then(function (me) {
                HousingAssociationsFactory.readIssues(
                    me.data.organization.party_uuid,
                    paramList
                ).then(function (response) {
                    vm.dataFromBackend = response.data.results;
                    vm.howManyElements = response.data.count;
                    vm.howManyCurrentElements = response.data.results.length;
                });
            });
        });

        vm.readJournal = function (issue_id, is_open, index) {
            if (is_open == true) {
                HaEmployeeFactory.readMe().then(function (me) {
                    HousingAssociationsFactory.readJournal(
                        me.data.organization.party_uuid,
                        issue_id,
                        { page_size: 100 }
                    ).then(function (response) {
                        vm.dataFromBackend[index].journal =
                            response.data.results;
                    });
                });
            }
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/history/history.controller.ts